module.exports = __webpack_public_path__ + "img/pet1.db82f238.jpg";